<ng-container *ngIf="enabled">
  <span [ngClass]="_style"
        [style.--primary-color]="primary"
        [style.--secondary-color]="secondary"
        [style.--size]="_size"
        [style.--border-size]="borderSize"
        [style.--diameter-diff]="diameterDiff"></span>
</ng-container>